export default __webpack_public_path__ + "static/media/IMG_9970.c496dd72.jpg";